import React, { Component } from 'react';
import {
    MagnifyingGlassIcon,
    FunnelIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    CalendarIcon,
    CheckCircleIcon,
    XCircleIcon,
    Bars3Icon,
    ArrowDownIcon,
} from '@heroicons/react/20/solid';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import ClipLoader from 'react-spinners/ClipLoader';
import Breadcrumb from '../../Shared/BreadCumb';
import ResponsiveTable from '../../Shared/ResponsiveTable';
import NoAccesComponent from '../../Shared/NoAccesComponent';
import { getPendingPayments, changePaymentStatus } from './services/payments';
import PaymentDetailModal from './PaymentDetailModal';

const STATUS_OPTIONS = [
    { value: -1, label: 'Todos' },
    { value: 1, label: 'Pendiente por validar' },
    { value: 2, label: 'Rechazado' },
    { value: 3, label: 'Aprobado' },
];

const FROM_OPTIONS = [
    { value: 0, label: 'Todos' },
    { value: 1, label: 'Administrativo' },
    { value: 2, label: 'Web' },
];

const TYPE_OPTIONS = [
    { value: 0, label: 'Todos' },
    { value: 5, label: 'Pago directo' },
];

const BANK_OPTIONS = [
    { value: '', label: 'Todos' },
    { value: '0102', label: '0102 - Banco de Venezuela' },
    { value: '0104', label: '0104 - Venezolano de Crédito' },
    { value: '0105', label: '0105 - Mercantil' },
    { value: '0108', label: '0108 - Provincial' },
    { value: '0114', label: '0114 - Bancaribe' },
    { value: '0115', label: '0115 - Exterior' },
    { value: '0128', label: '0128 - Banco Caroní' },
    { value: '0134', label: '0134 - Banesco' },
    { value: '0138', label: '0138 - Banco Plaza' },
    { value: '0146', label: '0146 - Bangente' },
    { value: '0151', label: '0151 - BFC' },
    { value: '0156', label: '0156 - 100% Banco' },
    { value: '0163', label: '0163 - Banco del Tesoro' },
    { value: '0166', label: '0166 - Banco Agrícola' },
    { value: '0168', label: '0168 - Bancrecer' },
    { value: '0169', label: '0169 - Mi Banco' },
    { value: '0172', label: '0172 - Bancamiga' },
    { value: '0174', label: '0174 - Banplus' },
    { value: '0175', label: '0175 - Banco Digital de los Trabajadores' },
    { value: '0177', label: '0177 - Banfanb' },
    { value: '0191', label: '0191 - BNC' },
    { value: "0171", label: "Banco Activo" },
];

const BREADCRUMB = [
    { name: 'Multas', href: '#', current: false },
    { name: 'Validación de Pagos', href: '#', current: true },
];

const statusBadge = (idStatus) => {
    switch (idStatus) {
        case 1: return { label: 'PENDIENTE', cls: 'bg-yellow-100 text-yellow-800' };
        case 2: return { label: 'RECHAZADO', cls: 'bg-red-100 text-red-800' };
        case 3: return { label: 'APROBADO', cls: 'bg-green-100 text-green-800' };
        default: return { label: 'DESCONOCIDO', cls: 'bg-gray-100 text-gray-800' };
    }
};

const formatAmount = (amount) => {
    if (amount == null) return '';
    return `Bs. ${amount}`;
};

const formatDateCell = (v) => {
    if (!v) return '';
    const d = new Date(v);
    if (isNaN(d.getTime())) return String(v);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

class PaymentValidation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // permisos
            loadingPermissions: true,
            canSee: false,
            canUpdate: false,

            // filtros
            identification: '',
            name: '',
            phone: '',
            bankCode: '',
            reference: '',
            dateStart: '',
            dateEnd: '',
            dateTrans: '',
            userName: '',
            idFrom: 0,
            idType: 0,
            idStatus: 1,
            limit: 100,

            // datos
            loading: false,
            payments: [],

            // UI
            isFiltersOpen: true,
            openMenuId: null,
            menuAnchorEl: null,

            // modales
            detailOpen: false,
            selectedPayment: null,

            actionDialog: null, // 'approve' | 'reject' | null
            actionComment: '',
            actionLoading: false,
        };
    }

    componentDidMount() {
        let permissions = window.localStorage.getItem('permissons');
        const userType = window.localStorage.getItem('userType');
        if (userType === 'ANALISTA') {
            try {
                permissions = JSON.parse(permissions) || [{}];
            } catch (e) {
                permissions = [{}];
            }
            const entries = permissions?.[0]?.paymentValidation || [];
            let canSee = false;
            let canUpdate = false;
            entries.forEach((el) => {
                if (el.name === 'see' && el.value === true) canSee = true;
                if (el.name === 'update' && el.value === true) canUpdate = true;
            });
            this.setState({ canSee, canUpdate, loadingPermissions: false });
        } else {
            this.setState({ canSee: true, canUpdate: true, loadingPermissions: false });
        }
    }

    buildBody = () => {
        const body = {};
        const s = this.state;
        if (s.identification) body.identification = s.identification;
        if (s.name) body.name = s.name;
        if (s.phone) body.phone = s.phone;
        if (s.bankCode) body.bankCode = s.bankCode;
        if (s.reference) body.reference = s.reference;
        if (s.userName) body.userName = s.userName;
        if (s.dateStart) body.dateStart = new Date(s.dateStart).toISOString();
        if (s.dateEnd) body.dateEnd = new Date(s.dateEnd).toISOString();
        if (s.dateTrans) body.dateTrans = new Date(s.dateTrans).toISOString();
        if (s.idFrom && parseInt(s.idFrom, 10) > 0) body.idFrom = parseInt(s.idFrom, 10);
        if (s.idType && parseInt(s.idType, 10) > 0) body.idType = parseInt(s.idType, 10);
        if (s.idStatus != null && parseInt(s.idStatus, 10) > 0) body.idStatus = parseInt(s.idStatus, 10);
        body.limit = parseInt(s.limit, 10);
        return body;
    };

    fetchData = () => {
        const body = this.buildBody();
        this.setState({ loading: true });
        getPendingPayments(body)
            .then((result) => {
                if (result && result.status === 200) {
                    const payload = result.data?.data;
                    const data = Array.isArray(payload?.data)
                        ? payload.data
                        : Array.isArray(payload)
                            ? payload
                            : [];
                    const sorted = [...data].sort((a, b) => {
                        const da = a.dateReg ? Date.parse(a.dateReg) : 0;
                        const db = b.dateReg ? Date.parse(b.dateReg) : 0;
                        return db - da;
                    });
                    this.setState({ payments: sorted, loading: false });
                } else {
                    toast(typeof result === 'string' ? result : 'No se pudieron obtener los pagos');
                    this.setState({ payments: [], loading: false });
                }
            })
            .catch((err) => {
                toast('Error al consultar pagos');
                this.setState({ loading: false });
                console.log(err);
            });
    };

    exportData = () => {
        const body = this.buildBody();
        body.isReportExcel = true;
        this.setState({ loading: true });
        getPendingPayments(body)
            .then((result) => {
                if (result && result.data?.data?.url) {
                    window.open(result.data.data.url);
                } else {
                    toast(typeof result === 'string' ? result : 'No se pudo generar el reporte');
                }
                this.setState({ loading: false });
            })
            .catch((err) => {
                toast('Error al generar el reporte');
                this.setState({ loading: false });
                console.log(err);
            });
    };

    clearFilters = () => {
        this.setState({
            identification: '', name: '', phone: '', bankCode: '',
            reference: '', dateStart: '', dateEnd: '', dateTrans: '', userName: '',
            idFrom: 0, idType: 0, idStatus: 1, limit: 100,
        });
    };

    toggleMenu = (id, anchorEl) => {
        this.setState((prev) => ({
            openMenuId: prev.openMenuId === id ? null : id,
            menuAnchorEl: anchorEl,
        }));
    };

    openDetail = (row) => {
        this.setState({ selectedPayment: row, detailOpen: true, openMenuId: null, menuAnchorEl: null });
    };

    openApprove = (row) => {
        this.setState({ selectedPayment: row, actionDialog: 'approve', actionComment: '', openMenuId: null, menuAnchorEl: null });
    };

    openReject = (row) => {
        this.setState({ selectedPayment: row, actionDialog: 'reject', actionComment: '', openMenuId: null, menuAnchorEl: null });
    };

    closeAction = () => {
        this.setState({ actionDialog: null, actionComment: '', actionLoading: false });
    };

    submitAction = () => {
        const { actionDialog, selectedPayment, actionComment } = this.state;
        if (!selectedPayment || !actionDialog) return;
        if (actionDialog === 'reject' && !actionComment.trim()) {
            toast('El comentario es obligatorio para rechazar');
            return;
        }
        const body = {
            id: selectedPayment.id,
            status: actionDialog === 'approve' ? 3 : 2,
            comment: actionComment,
        };
        this.setState({ actionLoading: true });
        changePaymentStatus(body)
            .then((result) => {
                if (result && result.status === 200) {
                    toast(actionDialog === 'approve' ? 'Pago aprobado' : 'Pago rechazado');
                    this.setState({ actionDialog: null, actionComment: '', actionLoading: false, selectedPayment: null });
                    this.fetchData();
                } else {
                    toast(typeof result === 'string' ? result : 'No se pudo actualizar el estatus');
                    this.setState({ actionLoading: false });
                }
            })
            .catch((err) => {
                toast('Error al actualizar el estatus');
                this.setState({ actionLoading: false });
                console.log(err);
            });
    };

    get columns() {
        return [
            { field: 'identification', headerName: 'Identificación' },
            { field: 'name', headerName: 'Nombre' },
            {
                field: 'amount',
                headerName: 'Monto',
                renderCell: (params) => formatAmount(params.row.amount),
            },
            { field: 'reference', headerName: 'Referencia' },
            {
                field: 'dateTrans',
                headerName: 'Fecha transferencia',
                renderCell: (params) => formatDateCell(params.row.dateTrans),
            },
            {
                field: 'idStatus',
                headerName: 'Estatus',
                renderCell: (params) => {
                    const b = statusBadge(params.row.idStatus);
                    return (
                        <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${b.cls}`}>
                            {b.label}
                        </span>
                    );
                },
            },
        ];
    }

    renderActions = (row) => {
        const isOpen = this.state.openMenuId === row.id;
        const canAct = this.state.canUpdate && row.idStatus === 1;
        return (
            <>
                <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        this.toggleMenu(row.id, e.currentTarget);
                    }}
                    aria-haspopup="true"
                    title="Acciones"
                >
                    <Bars3Icon className="h-5 w-5 text-emerald-900" />
                </IconButton>
                <Menu
                    anchorEl={this.state.menuAnchorEl}
                    open={isOpen}
                    onClose={() => this.toggleMenu(row.id, null)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    MenuListProps={{ onClick: (e) => e.stopPropagation() }}
                >
                    <MenuItem onClick={() => this.openDetail(row)}>
                        <ListItemIcon><MagnifyingGlassIcon className="h-5 w-5 text-gray-900" /></ListItemIcon>
                        <ListItemText primary="Ver detalle" />
                    </MenuItem>
                    {canAct && (
                        <MenuItem onClick={() => this.openApprove(row)}>
                            <ListItemIcon><CheckCircleIcon className="h-5 w-5 text-green-700" /></ListItemIcon>
                            <ListItemText primary="Aprobar" />
                        </MenuItem>
                    )}
                    {canAct && (
                        <MenuItem onClick={() => this.openReject(row)}>
                            <ListItemIcon><XCircleIcon className="h-5 w-5 text-red-700" /></ListItemIcon>
                            <ListItemText primary="Rechazar" />
                        </MenuItem>
                    )}
                </Menu>
            </>
        );
    };

    renderFilters() {
        const s = this.state;
        return (
            <div className="mt-8 bg-white rounded-lg shadow-sm ring-1 ring-gray-200">
                <div className="flex items-center justify-between p-4 border-b border-gray-200">
                    <div className="flex items-center space-x-2">
                        <FunnelIcon className="h-5 w-5 text-gray-500" />
                        <h3 className="text-lg font-semibold text-gray-900">Filtros de Búsqueda</h3>
                    </div>
                    <button
                        onClick={() => this.setState({ isFiltersOpen: !s.isFiltersOpen })}
                        className="flex items-center text-sm text-gray-600 hover:text-gray-900"
                    >
                        {s.isFiltersOpen ? 'Ocultar' : 'Mostrar'} filtros
                        {s.isFiltersOpen ? <ChevronUpIcon className="ml-1 h-4 w-4" /> : <ChevronDownIcon className="ml-1 h-4 w-4" />}
                    </button>
                </div>

                {s.isFiltersOpen && (
                    <div className="p-6">
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Identificación</label>
                                <input value={s.identification} onChange={(e) => this.setState({ identification: e.target.value })} onKeyDown={(e) => e.key === 'Enter' && this.fetchData()} type="text" className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Nombre</label>
                                <input value={s.name} onChange={(e) => this.setState({ name: e.target.value })} onKeyDown={(e) => e.key === 'Enter' && this.fetchData()} type="text" className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Teléfono</label>
                                <input value={s.phone} onChange={(e) => this.setState({ phone: e.target.value })} onKeyDown={(e) => e.key === 'Enter' && this.fetchData()} type="text" className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Referencia</label>
                                <input value={s.reference} onChange={(e) => this.setState({ reference: e.target.value })} onKeyDown={(e) => e.key === 'Enter' && this.fetchData()} type="text" className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Banco emisor</label>
                                <select value={s.bankCode} onChange={(e) => this.setState({ bankCode: e.target.value })} className="block w-full rounded-md border-0 py-2 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm">
                                    {BANK_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                                </select>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Usuario</label>
                                <input value={s.userName} onChange={(e) => this.setState({ userName: e.target.value })} type="text" className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2"><CalendarIcon className="inline h-4 w-4 mr-1" />Fecha Desde</label>
                                <input value={s.dateStart} onChange={(e) => this.setState({ dateStart: e.target.value })} type="date" className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2"><CalendarIcon className="inline h-4 w-4 mr-1" />Fecha Hasta</label>
                                <input value={s.dateEnd} onChange={(e) => this.setState({ dateEnd: e.target.value })} type="date" className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2"><CalendarIcon className="inline h-4 w-4 mr-1" />Fecha Transferencia</label>
                                <input value={s.dateTrans} onChange={(e) => this.setState({ dateTrans: e.target.value })} type="date" className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Origen</label>
                                <select value={s.idFrom} onChange={(e) => this.setState({ idFrom: parseInt(e.target.value, 10) })} className="block w-full rounded-md border-0 py-2 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm">
                                    {FROM_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                                </select>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de pago</label>
                                <select value={s.idType} onChange={(e) => this.setState({ idType: parseInt(e.target.value, 10) })} className="block w-full rounded-md border-0 py-2 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm">
                                    {TYPE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                                </select>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Estatus</label>
                                <select value={s.idStatus} onChange={(e) => this.setState({ idStatus: parseInt(e.target.value, 10) })} className="block w-full rounded-md border-0 py-2 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm">
                                    {STATUS_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                                </select>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Límite</label>
                                <select value={s.limit} onChange={(e) => this.setState({ limit: parseInt(e.target.value, 10) })} className="block w-full rounded-md border-0 py-2 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm">
                                    <option value={10}>10 registros</option>
                                    <option value={50}>50 registros</option>
                                    <option value={100}>100 registros</option>
                                    <option value={500}>500 registros</option>
                                    <option value={1000}>1000 registros</option>
                                </select>
                            </div>
                        </div>

                        <div className="mt-6 flex flex-col sm:flex-row gap-3">
                            <button
                                onClick={this.fetchData}
                                type="button"
                                style={{ height: 40 }}
                                className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-white bg-blue-950 rounded-md shadow-sm hover:bg-blue-900"
                            >
                                <MagnifyingGlassIcon className="h-4 w-4 mr-2" />
                                Buscar Pagos
                            </button>
                            <button
                                onClick={this.exportData}
                                type="button"
                                style={{ height: 40 }}
                                className="inline-flex items-center justify-center gap-x-1.5 px-4 py-2 text-sm font-semibold text-white bg-green-700 rounded-md shadow-sm hover:bg-green-600"
                            >
                                <ArrowDownIcon className="h-4 w-4" />
                                Descargar Excel
                            </button>
                            <button
                                onClick={this.clearFilters}
                                type="button"
                                style={{ height: 40 }}
                                className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-white bg-red-700 rounded-md shadow-sm hover:bg-red-600"
                            >
                                Limpiar
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    renderActionDialog() {
        const { actionDialog, actionComment, actionLoading, selectedPayment } = this.state;
        if (!actionDialog) return null;
        const isApprove = actionDialog === 'approve';
        return (
            <Dialog open={!!actionDialog} onClose={this.closeAction} className="relative z-[55]">
                <DialogBackdrop className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm z-40" />
                <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <DialogPanel className="relative w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden">
                            <div className={`px-6 py-4 ${isApprove ? 'bg-green-700' : 'bg-red-700'}`}>
                                <div className="flex items-center">
                                    {isApprove
                                        ? <CheckCircleIcon className="h-6 w-6 text-white mr-3" />
                                        : <XCircleIcon className="h-6 w-6 text-white mr-3" />}
                                    <h3 className="text-lg font-bold text-white">
                                        {isApprove ? 'Aprobar pago' : 'Rechazar pago'}
                                    </h3>
                                    <button
                                        type="button"
                                        onClick={this.closeAction}
                                        className="ml-auto rounded-full p-1 text-white/80 hover:text-white hover:bg-white/20"
                                    >
                                        <XMarkIcon className="h-5 w-5" />
                                    </button>
                                </div>
                            </div>
                            <div className="px-6 py-6 space-y-4">
                                <p className="text-sm text-gray-700">
                                    {isApprove
                                        ? '¿Estás seguro que deseas aprobar este pago? Esta acción cambiará el estatus a APROBADO.'
                                        : '¿Estás seguro que deseas rechazar este pago? Es obligatorio indicar un comentario con el motivo del rechazo.'}
                                </p>
                                <div className="bg-gray-50 rounded-lg p-3 text-sm text-gray-700 space-y-1">
                                    <div><span className="text-gray-500">Identificación: </span><span className="font-medium">{selectedPayment?.identification}</span></div>
                                    <div><span className="text-gray-500">Nombre: </span><span className="font-medium">{selectedPayment?.name}</span></div>
                                    <div><span className="text-gray-500">Monto: </span><span className="font-medium">{formatAmount(selectedPayment?.amount)}</span></div>
                                    <div><span className="text-gray-500">Referencia: </span><span className="font-medium">{selectedPayment?.reference}</span></div>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Comentario {isApprove ? '(opcional)' : <span className="text-red-500">*</span>}
                                    </label>
                                    <textarea
                                        value={actionComment}
                                        onChange={(e) => this.setState({ actionComment: e.target.value })}
                                        rows={3}
                                        className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                        placeholder={isApprove ? 'Comentario (opcional)' : 'Indique el motivo del rechazo'}
                                    />
                                </div>
                            </div>
                            <div className="bg-gray-50 px-6 py-4 flex justify-end gap-3">
                                <button
                                    type="button"
                                    onClick={this.closeAction}
                                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    disabled={actionLoading}
                                    onClick={this.submitAction}
                                    className={`px-4 py-2 text-sm font-semibold text-white rounded-lg shadow-sm ${isApprove ? 'bg-green-700 hover:bg-green-600' : 'bg-red-700 hover:bg-red-600'} disabled:opacity-60`}
                                >
                                    {actionLoading
                                        ? <ClipLoader color="#ffffff" size={16} />
                                        : (isApprove ? 'Confirmar aprobación' : 'Confirmar rechazo')}
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        );
    }

    renderBody() {
        return (
            <div className="max-w-7xl mx-auto px-4">
                <div className="py-6">
                    <Breadcrumb pages={BREADCRUMB} />

                    <div className="mb-8">
                        <h2 className="text-2xl font-bold text-gray-900 mb-2">Validación de Pagos</h2>
                        <p className="text-gray-600">Revisa, aprueba o rechaza los pagos reportados por los usuarios.</p>
                    </div>

                    {this.renderFilters()}

                    {this.state.loading && (
                        <div className="text-center py-12">
                            <ClipLoader color={'#1e40af'} loading={true} size={50} />
                            <p className="mt-2 text-sm text-gray-600">Cargando pagos...</p>
                        </div>
                    )}

                    {!this.state.loading && (
                        <div className="mt-8 bg-white rounded-lg shadow-sm ring-1 ring-gray-200 overflow-hidden">
                            <div className="px-6 py-4 border-b border-gray-200">
                                <h3 className="text-lg font-semibold text-gray-900">Resultados</h3>
                                <p className="text-sm text-gray-600">
                                    {this.state.payments.length} pago(s) encontrado(s)
                                </p>
                            </div>
                            <div className="w-full">
                                <ResponsiveTable
                                    data={this.state.payments}
                                    columns={this.columns}
                                    onRowClick={(row) => this.openDetail(row)}
                                    renderActions={(row) => this.renderActions(row)}
                                />
                            </div>
                        </div>
                    )}
                </div>

                <PaymentDetailModal
                    open={this.state.detailOpen}
                    payment={this.state.selectedPayment}
                    onClose={() => this.setState({ detailOpen: false })}
                />

                {this.renderActionDialog()}

                <ToastContainer position="top-center" hideProgressBar={true} />
            </div>
        );
    }

    render() {
        if (this.state.loadingPermissions) {
            return (
                <div className="text-center py-12">
                    <ClipLoader color="gray" size={50} />
                </div>
            );
        }
        return this.state.canSee ? this.renderBody() : <NoAccesComponent />;
    }
}

export default PaymentValidation;
